import { SkinSelector } from '../../propertyPanel/CommonProperties/SkinSelector';
import { COMPONENT_TYPES } from '../../../constants';

/**
 * 로그인 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const LoginProperties = [
  {
    group: '스킨 설정',
    properties: [
      {
        name: 'componentProps.skin',
        label: '스킨 선택',
        control: SkinSelector,
        componentType: COMPONENT_TYPES.LOGIN || 'LOGIN',
        defaultValue: 'basic'
      }
    ]
  },
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목 텍스트',
        control: 'TextField',
        defaultValue: '로그인'
      },
      {
        name: 'componentProps.redirectUrl',
        label: '로그인 후 이동 경로',
        control: 'TextField',
        defaultValue: '/',
        description: '이미 로그인된 경우 또는 로그인 성공 시 이동할 경로를 지정하세요.'
      }
    ]
  },
  {
    group: '배경 설정',
    properties: [
      {
        name: 'componentProps.backgroundType',
        label: '배경 타입',
        control: 'SelectField',
        options: [
          { value: 'none', label: '없음' },
          { value: 'image', label: '이미지' },
          { value: 'video', label: '비디오' }
        ],
        defaultValue: 'image'
      },
      {
        name: 'componentProps.backgroundUrl',
        label: '배경 URL',
        control: 'TextField',
        defaultValue: '',
        placeholder: 'https://example.com/bg.jpg 또는 .mp4'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.buttonColor',
        label: '버튼 색상',
        control: 'ColorPicker',
        defaultValue: '#4a90e2'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'SelectField',
        options: [
          { value: 'none', label: '없음' },
          { value: '0 2px 5px rgba(0, 0, 0, 0.1)', label: '약함' },
          { value: '0 2px 10px rgba(0, 0, 0, 0.1)', label: '보통' },
          { value: '0 4px 15px rgba(0, 0, 0, 0.15)', label: '강함' }
        ],
        defaultValue: '0 2px 10px rgba(0, 0, 0, 0.1)'
      }
    ]
  },

];

export default LoginProperties; 